<template>
  <v-layout class="promo-container">
    <v-flex lg3>
      <v-container>
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h1 class="text-md-center earth-color">ADD DISCOUNT</h1>
            <div class="title-decoration"></div>
          </div>
          <v-container>
            <v-select
              label="Promo Code Type"
              v-model="promo_code.promo_code_type_id"
              :rules="requiredRules"
              :items="$allProductCodeTypes"
              item-text="name"
              item-value="public_id"
              required
              class="futuristic-input"
            ></v-select>
            <v-text-field
              label="Discount Code"
              v-model="promo_code.code"
              class="futuristic-input"
            ></v-text-field>
            <v-select
              label="Promo Code Type"
              v-model="promo_code.type"
              :rules="requiredRules"
              :items="types"
              item-text="name"
              item-value="type"
              required
              @change="valueSelected1()"
              class="futuristic-input"
            ></v-select>
            <v-text-field
              label="Maximum Uses"
              v-model="promo_code.max_uses"
              :rules="requiredRules"
              type="number"
              class="futuristic-input"
            ></v-text-field>
            <v-text-field
              label="Discount Amount"
              v-model="promo_code.amount"
              class="futuristic-input"
            ></v-text-field>
            <v-select
              label="Application"
              v-model="promo_code.tax"
              :rules="requiredRules"
              :items="tx_values"
              item-text="name"
              item-value="tax_id"
              required
              @change="valueSelected()"
              class="futuristic-input"
            ></v-select>
            <v-select
              label="Recurrence"
              v-model="promo_code.recurrence"
              :rules="requiredRules"
              :items="recurrence"
              item-text="name"
              item-value="type_id"
              required
              @change="valueSelected()"
              class="futuristic-input"
            ></v-select>
            <v-dialog
              ref="dialog"
              persistent
              v-model="modal1"
              lazy
              full-width
              width="290px"
              :return-value.sync="promo_code.start_date"
            >
              <v-text-field
                slot="activator"
                label="Start Date"
                v-model="promo_code.start_date"
                readonly
                class="futuristic-input"
              ></v-text-field>
              <v-date-picker
                v-model="promo_code.start_date"
                :min="start_date"
                scrollable
                class="futuristic-picker"
              >
                <v-spacer></v-spacer>
                <v-btn depressed class="futuristic-btn" color="#2196f3" @click="modal1 = false">Cancel</v-btn>
                <v-btn depressed class="futuristic-btn" color="#587e27" @click="$refs.dialog.save(promo_code.start_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="dialog1"
              persistent
              v-model="modal2"
              lazy
              full-width
              width="290px"
              :return-value.sync="promo_code.end_date"
            >
              <v-text-field
                slot="activator"
                label="End Date"
                v-model="promo_code.end_date"
                readonly
                v-if="show_end_date === true"
                class="futuristic-input"
              ></v-text-field>
              <v-date-picker
                v-model="promo_code.end_date"
                :min="promo_code.start_date"
                scrollable
                class="futuristic-picker"
              >
                <v-spacer></v-spacer>
                <v-btn depressed class="futuristic-btn" color="#2196f3" @click="modal2 = false">Cancel</v-btn>
                <v-btn depressed class="futuristic-btn" color="#587e27" @click="$refs.dialog1.save(promo_code.end_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-autocomplete
              label="Currency"
              :items="$allCurrencies"
              :rules="[v => !!v || 'Currency is required']"
              required
              v-model="promo_code.currency"
              :return-object="true"
              item-text="currency_name"
              item-value="currency_public_id"
              :loading="$loadingTrue"
              @change="selectedPaymentCurrency"
              v-if="show_currency === true"
              class="futuristic-input"
            ></v-autocomplete>
            <v-switch
              label="All"
              color="#587e27"
              v-model="promo_code.all"
              required
              @change="allIsSelected()"
              class="futuristic-switch"
            ></v-switch>
            <v-expansion-panel popout class="futuristic-expansion">
              <v-expansion-panel-content>
                <div slot="header"><input v-if="entry_fees === true" type="checkbox" checked /> Entry Fees</div>
                <v-card class="futuristic-card">
                  <v-container>
                    <v-card-text v-for="(fee, idx) in allConservationFees" :key="idx">
                      <input class="form-check-input" type="checkbox" :value="fee.payment_public_id" :id="fee.payment_public_id" v-model="promo_code.conservation_fee" @click="isConservationSelected($event)"> {{fee.payment_person}}
                    </v-card-text>
                  </v-container>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel popout class="futuristic-expansion">
              <v-expansion-panel-content>
                <div slot="header"><input v-if="v_fees === true" type="checkbox" checked /> Vehicle Fees</div>
                <v-card class="futuristic-card">
                  <v-container>
                    <v-card-text v-for="(vehicle, key) in allVehicles" :key="key">
                      <input class="form-check-input" type="checkbox" :value="vehicle.vehicle_charge_public_id" :id="vehicle.vehicle_charge_public_id" v-model="promo_code.vehicle_fee" @click="isVehicleSelected($event)"> {{vehicle.vehicle_charge_category}}
                    </v-card-text>
                  </v-container>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel popout class="futuristic-expansion">
              <v-expansion-panel-content>
                <div slot="header"><input v-if="facility === true" type="checkbox" checked /> Accommodations & Campsites</div>
                <v-card class="futuristic-card">
                  <v-container>
                    <v-card-text v-for="(accommodation, idx) in allActiveAccommodationCampsite" :key="idx">
                      <input class="form-check-input" type="checkbox" :value="accommodation.public_id" :id="accommodation.public_id" v-model="promo_code.accommodation" @click="isAccommodationSelected($event)"> {{accommodation.name}}
                    </v-card-text>
                  </v-container>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel popout class="futuristic-expansion">
              <v-expansion-panel-content>
                <div slot="header"><input v-if="facility === true" type="checkbox" checked /> Activities</div>
                <v-card class="futuristic-card">
                  <v-container>
                    <v-card-text v-for="(activity, idx) in inventoryWithPrices" :key="idx">
                      <input class="form-check-input" type="checkbox" :value="activity.public_id" :id="activity.public_id" v-model="promo_code.activities" @click="isActivitySelected($event)"> {{activity.name}}
                    </v-card-text>
                  </v-container>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <br/>
            <v-btn class="futuristic-btn" color="#587e27" block v-if="edit === false" @click="postPromoCode()" :loading="this.$store.state.LoadingStore.loading">ADD DISCOUNT</v-btn>
            <v-btn class="futuristic-btn" color="#fbc531" block v-if="edit === true" @click="postUpdatePromoCode()" :loading="this.$store.state.LoadingStore.loading">UPDATE DISCOUNT</v-btn>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex lg9>
      <v-card flat class="futuristic-card">
        <div class="card-header">
          <h1 class="text-md-center earth-color">PROMO CODES</h1>
          <div class="title-decoration"></div>
        </div>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            placeholder="Search promo codes..."
            single-line
            hide-details
            v-model="search"
            class="futuristic-input"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="columns"
          :items="$allPromoCodes"
          :search="search"
          :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
          :disable-initial-sort="true"
          :loading="$loadingTrue"
          class="futuristic-table"
        >
          <v-progress-linear
            slot="progress"
            color="#587e27"
            indeterminate
            height="3"
          ></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.start_date }} to {{ props.item.end_date }}</td>
            <td class="font-weight-medium">{{ props.item.code }}</td>
            <td>{{ props.item.promo_code_type }}</td>
            <td>{{ props.item.max_uses }}</td>
            <td v-if="props.item.amount_discount === true">{{ props.item.amount_off_currency_name }} {{ props.item.amount_off }}</td>
            <td v-if="props.item.percentage_discount === true">{{ props.item.percentage_off }}%</td>
            <td>
              <v-btn depressed class="futuristic-btn action-btn" color="#ef5350" small v-if="edit === false" @click="deletePromoCode(props.item.public_id)">Delete</v-btn>
              <router-link :to="{name: 'PromoCodeUsage', params: {promo_code_id: props.item.public_id}}">
                <v-btn depressed class="futuristic-btn action-btn" color="#2196f3" small v-if="edit === false">View Usage</v-btn>
              </router-link>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'GeneratePromoCodes',
  created () {
    this.$store.dispatch('get_all_promo_code_types')
    this.$store.dispatch('get_all_promo_codes')
    this.$store.dispatch('get_all_conservation_fees')
    this.$store.dispatch('get_all_vehicle_fees')
    this.$store.dispatch('get_active_accommodation_campsite')
    this.$store.dispatch('get_active_activities')
  },
  data () {
    return {
      active: null,
      search: '',
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      types: [
        { 'name': 'Fixed Amount', 'type': '1' },
        { 'name': 'Percent', 'type': '2' }
      ],
      recurrence: [
        { 'name': 'One Time', 'type_id': '1' },
        { 'name': 'Always (Does not expire)', 'type_id': '2' }
      ],
      tx_values: [
        { 'name': 'Per Item', 'tax_id': '1' },
        { 'name': 'Per Booking', 'tax_id': '2' }
      ],
      edit: false,
      start_date: this.$moment().format('YYYY-MM-DD'),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      one_time: false,
      show_end_date: true,
      show_currency: false,
      entry_fees: false,
      v_fees: false,
      inventory: false,
      facility: false,
      promo_code: {
        promo_code_type_id: '',
        recurrence: '',
        amount: '',
        code: '',
        type: '',
        start_date: '',
        end_date: '',
        max_uses: '',
        currency: '',
        all: '',
        tax: '',
        activities: [],
        accommodation: [],
        conservation_fee: [],
        vehicle_fee: [],
        public_id: ''
      },
      columns: [
        {
          text: 'Duration',
          value: '',
          class: 'table-header'
        },
        {
          text: 'Code',
          value: 'last_name',
          class: 'table-header'
        },
        {
          text: 'Code Type',
          value: 'promo_code_type',
          class: 'table-header'
        },
        {
          text: 'Maximum Uses',
          value: 'max_uses',
          class: 'table-header'
        },
        {
          text: 'Discount',
          class: 'table-header'
        },
        {
          text: 'Action',
          value: '',
          class: 'table-header'
        }
      ]
    }
  },
  methods: {
    selectedPaymentCurrency () {
      this.promo_code.currency = this.promo_code.currency.currency_public_id
    },
    isConservationSelected: function (e) {
      if (e.target.checked) {
        this.promo_code.conservation_fee.push(e.target.value)
      } else {
        let value = this.promo_code.conservation_fee.indexOf(e.target.value)
        if (value !== -1) {
          this.promo_code.conservation_fee.splice(value, 1)
        }
      }
    },
    isVehicleSelected: function (e) {
      if (e.target.checked) {
        this.promo_code.vehicle_fee.push(e.target.value)
      } else {
        let value = this.promo_code.vehicle_fee.indexOf(e.target.value)
        if (value !== -1) {
          this.promo_code.vehicle_fee.splice(value, 1)
        }
      }
    },
    isActivitySelected: function (e) {
      if (e.target.checked) {
        this.promo_code.activities.push(e.target.value)
      } else {
        let value = this.promo_code.activities.indexOf(e.target.value)
        if (value !== -1) {
          this.promo_code.activities.splice(value, 1)
        }
      }
    },
    isAccommodationSelected: function (e) {
      if (e.target.checked) {
        this.promo_code.accommodation.push(e.target.value)
      } else {
        let value = this.promo_code.accommodation.indexOf(e.target.value)
        if (value !== -1) {
          this.promo_code.accommodation.splice(value, 1)
        }
      }
    },
    allEntryIsSelected () {},
    allIsSelected () {
      if (this.promo_code.all === true) {
        this.entry_fees = true
        this.v_fees = true
        this.inventory = true
        this.facility = true
        for (var vehicle = 0; vehicle < this.allVehicles.length; vehicle++) {
          this.promo_code.vehicle_fee.push(this.allVehicles[vehicle].vehicle_charge_public_id)
        }
        for (var fee = 0; fee < this.allConservationFees.length; fee++) {
          this.promo_code.conservation_fee.push(this.allConservationFees[fee].payment_public_id)
        }
        for (var activity = 0; activity < this.inventoryWithPrices.length; activity++) {
          this.promo_code.activities.push(this.inventoryWithPrices[activity].public_id)
        }
        for (var accommodation = 0; accommodation < this.allAccommodations.length; accommodation++) {
          this.promo_code.accommodation.push(this.allAccommodations[accommodation].public_id)
        }
      } else {
        this.promo_code.all = false
        this.entry_fees = false
        this.v_fees = false
        this.inventory = false
        this.facility = false
        this.promo_code.vehicle_fee = []
        this.promo_code.activities = []
        this.promo_code.accommodation = []
        this.promo_code.conservation_fee = []
      }
    },
    isSelected () {
      if (this.promo_code.all === true) {
        this.promo_code.all = false
      }
    },
    selectAll () {
      if (this.promo_code.all === true) {
        this.promo_code.conservation_fee = true
        this.promo_code.vehicle_fee = true
        this.promo_code.accommodation = true
        this.promo_code.activities = true
      } else {
        this.promo_code.conservation_fee = false
        this.promo_code.vehicle_fee = false
        this.promo_code.accommodation = false
        this.promo_code.activities = false
      }
    },
    valueSelected () {
      if (this.promo_code.recurrence === '2') {
        this.show_end_date = false
      } else {
        this.show_end_date = true
      }
    },
    valueSelected1 () {
      if (this.promo_code.type === '1') {
        this.show_currency = true
      } else {
        this.show_currency = false
      }
    },
    postPromoCode () {
      this.$store.dispatch('post_promo_code', this.promo_code)
    },
    postUpdatePromoCode () {
      this.$store.dispatch('update_promo_code', this.promo_code)
    },
    editPromoCode (promoCode) {
      this.edit = true
      this.promo_code.public_id = promoCode.public_id
      this.promo_code.conservation_fee = promoCode.conservancy_fee
      this.promo_code.vehicle_fee = promoCode.vehicle_fee
      this.promo_code.accommodation = promoCode.accommodation
      this.promo_code.activities = promoCode.activities
      this.promo_code.amount = promoCode.amount
      this.promo_code.code = promoCode.code
      this.promo_code.max_uses = promoCode.max_uses
      this.promo_code.promo_code_type_id = promoCode.promo_code_type_id
      this.promo_code.start_date = promoCode.start_date
      this.promo_code.end_date = promoCode.end_date
      if (promoCode.amount_discount === true) {
        this.promo_code.amount = promoCode.amount_off
        this.promo_code.currency = promoCode.amount_off_currency
        this.promo_code.type = '1'
        this.promo_code.recurrence = '1'
        this.show_end_date = false
      }
      if (promoCode.percentage_discount === true) {
        this.promo_code.amount = promoCode.percentage_off
        this.promo_code.recurrence = '2'
        this.promo_code.type = '2'
      }
    },
    cancelEdit () {
      this.edit = false
      this.promo_code.conservation_fee = ''
      this.promo_code.vehicle_fee = ''
      this.promo_code.accommodation = ''
      this.promo_code.activities = ''
      this.promo_code.amount = ''
      this.promo_code.code = ''
      this.promo_code.max_uses = ''
      this.promo_code.promo_code_type_id = ''
      this.promo_code.start_date = ''
      this.promo_code.end_date = ''
      this.promo_code.currency = ''
      this.promo_code.recurrence = ''
      this.promo_code.type = ''
      this.promo_code.public_id = ''
    },
    deletePromoCode (publicId) {
      this.$store.dispatch('delete_promo_code', publicId)
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.promo-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.promo-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.futuristic-switch >>> .v-input--switch__thumb {
  background: #587e27;
}

.futuristic-expansion >>> .v-expansion-panel__header {
  background: #f5f7fa;
  border-radius: 8px;
}

.futuristic-picker {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .promo-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-btn {
    margin: 2px;
  }
}

@media (max-width: 600px) {
  .promo-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>